// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 주렁주렁 운영 도구 - 글로벌 스타일 (현장 데스크용 - 큰 폰트)
 */

* {
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: 24px;  /* 기본 폰트 크기 확대: 16px → 24px */
  line-height: 1.5;
  color: #212529;
  background-color: #f5f7fa;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  overflow-x: hidden;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 버튼 기본 스타일 */
button {
  font-family: inherit;
  font-size: 20px;  /* 버튼 기본 폰트 확대 */
}

/* 스크롤바 스타일 */
::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 공통 지점 배지 */
.store-badge-inline {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background: #F3E5F5;
  border: 1px solid #CE93D8;
  border-radius: 16px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 13px;
  color: #7B1FA2;
  font-weight: 500;
  white-space: nowrap;
  min-height: auto;
}

/* 태블릿 터치 최적화 - 더 큰 터치 영역 */
button,
input,
select,
textarea {
  min-height: 60px;  /* 44px → 60px */
  font-size: 20px;
}

/* 빌드 버전 표시 */
.build-version {
  position: fixed;
  bottom: 4px;
  right: 8px;
  font-size: 10px;
  color: rgba(0, 0, 0, 0.5);
  pointer-events: none;
  z-index: 99999;
  font-family: monospace;
}


/* 태블릿 Chrome 텍스트 검색 제안 방지 */
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,uGAAuG;EACvG,eAAe,GAAG,6BAA6B;EAC/C,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,eAAe,GAAG,gBAAgB;AACpC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;;;EAIE,gBAAgB,GAAG,gBAAgB;EACnC,eAAe;AACjB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;;AAGA,4BAA4B;AAC5B;EACE,wCAAwC;EACxC,2BAA2B;AAC7B","sourcesContent":["/**\n * 주렁주렁 운영 도구 - 글로벌 스타일 (현장 데스크용 - 큰 폰트)\n */\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  font-size: 24px;  /* 기본 폰트 크기 확대: 16px → 24px */\n  line-height: 1.5;\n  color: #212529;\n  background-color: #f5f7fa;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  overflow-x: hidden;\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 버튼 기본 스타일 */\nbutton {\n  font-family: inherit;\n  font-size: 20px;  /* 버튼 기본 폰트 확대 */\n}\n\n/* 스크롤바 스타일 */\n::-webkit-scrollbar {\n  width: 12px;\n  height: 12px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c4c4c4;\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* 공통 지점 배지 */\n.store-badge-inline {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 12px;\n  background: #F3E5F5;\n  border: 1px solid #CE93D8;\n  border-radius: 16px;\n  font-family: 'Noto Sans KR', sans-serif;\n  font-size: 13px;\n  color: #7B1FA2;\n  font-weight: 500;\n  white-space: nowrap;\n  min-height: auto;\n}\n\n/* 태블릿 터치 최적화 - 더 큰 터치 영역 */\nbutton,\ninput,\nselect,\ntextarea {\n  min-height: 60px;  /* 44px → 60px */\n  font-size: 20px;\n}\n\n/* 빌드 버전 표시 */\n.build-version {\n  position: fixed;\n  bottom: 4px;\n  right: 8px;\n  font-size: 10px;\n  color: rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n  z-index: 99999;\n  font-family: monospace;\n}\n\n\n/* 태블릿 Chrome 텍스트 검색 제안 방지 */\n* {\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
